/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    VccCredentialsV2OrderValue,
    VccCredentialsV2OrderValueFromJSON,
    VccCredentialsV2OrderValueFromJSONTyped,
    VccCredentialsV2OrderValueToJSON,
} from './';

/**
 * 
 * @export
 * @interface VccCredentialsV2Query
 */
export interface VccCredentialsV2Query {
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof VccCredentialsV2Query
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof VccCredentialsV2Query
     */
    cardProvider?: GuidIdAndLabel;
    /**
     * 
     * @type {string}
     * @memberof VccCredentialsV2Query
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VccCredentialsV2Query
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VccCredentialsV2Query
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof VccCredentialsV2Query
     */
    limit?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VccCredentialsV2Query
     */
    orderByDescending?: boolean;
    /**
     * 
     * @type {VccCredentialsV2OrderValue}
     * @memberof VccCredentialsV2Query
     */
    orderValue?: VccCredentialsV2OrderValue;
}

export function VccCredentialsV2QueryFromJSON(json: any): VccCredentialsV2Query {
    return VccCredentialsV2QueryFromJSONTyped(json, false);
}

export function VccCredentialsV2QueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): VccCredentialsV2Query {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'cardProvider': !exists(json, 'cardProvider') ? undefined : GuidIdAndLabelFromJSON(json['cardProvider']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'orderByDescending': !exists(json, 'orderByDescending') ? undefined : json['orderByDescending'],
        'orderValue': !exists(json, 'orderValue') ? undefined : VccCredentialsV2OrderValueFromJSON(json['orderValue']),
    };
}

export function VccCredentialsV2QueryToJSON(value?: VccCredentialsV2Query | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'cardProvider': GuidIdAndLabelToJSON(value.cardProvider),
        'description': value.description,
        'showDisabled': value.showDisabled,
        'offset': value.offset,
        'limit': value.limit,
        'orderByDescending': value.orderByDescending,
        'orderValue': VccCredentialsV2OrderValueToJSON(value.orderValue),
    };
}


